// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"255":"d2b2a8a9","293":"c51435d7","531":"de0dcbfa","622":"3f0a887a"}[chunkId] + ".css";
};